import React from "react";
import ReactDOM from "react-dom/client";
import { ParallaxProvider } from 'react-scroll-parallax';

import {AlertProvider} from "./components/common/Alert";
import "./index.css";
import "./fonts/Helvetica.ttf";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AlertProvider>
      <ParallaxProvider>
        <App />
      </ParallaxProvider>
    </AlertProvider>
  </React.StrictMode>
);
